<template>
  <div id="navigation">
    <button
      type="button"
      class="navBtn"
      @click="showNumbers"
      :class="{ blurred: this.numbersAreHidden }"
      :disabled="quizActive"
      :aria-label="
        quizActive
          ? 'Liczby są ukryte podczas quizu'
          : numbersAreHidden
          ? 'Pokaż liczby'
          : 'Ukryj liczby'
      "
    >
      👁️
    </button>
    <button
      type="button"
      class="navBtn"
      @click="randomize"
      :class="{ rotateCenter: this.isActive }"
      aria-label="Wylosuj wszystkie liczby"
    >
      🎲
    </button>
    <!-- <div class="navBtn" @click="randomize">🔥</div> -->
    <button
      type="button"
      class="navBtn"
      @click="toggleColorLegend"
      aria-label="Pokaż lub ukryj legendę kolorów"
    >
      🌈
    </button>
    <button
      type="button"
      class="navBtn"
      @click="$emit('toggle-quiz')"
      aria-label="Włącz lub wyłącz tryb quizu"
    >
      ✍️
    </button>
    <button
      type="button"
      class="navBtn"
      @click="$emit('toggle-number-generator')"
      aria-label="Otwórz generator liczby"
    >
      🔢
    </button>
    <!-- <div class="navBtn" @click="toggleColorLegend">🍔</div> -->
    <!-- <div class="navBtn">👽🐙✔️</div> -->
  </div>
</template>

<script>
export default {
  props: {
    quizActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      numbersAreHidden: true,
      isActive: false,
    };
  },

  emits: [
    'clicked-randomizer',
    'toggle-color-legend',
    'show-numbers',
    'toggle-quiz',
    'toggle-number-generator',
  ],

  methods: {
    randomize() {
      this.$emit('clicked-randomizer');
      this.isActive = true;
      setTimeout(() => {
        this.isActive = false;
      }, 500);
    },
    toggleColorLegend() {
      this.$emit('toggle-color-legend');
    },
    showNumbers() {
      this.$emit('show-numbers');
    },
    toggleNumbers() {
      this.numbersAreHidden = !this.numbersAreHidden;
    },
  },
};
</script>

<style>
#navigation {
  z-index: 100;
  position: fixed;
  /* height: 44px; */
  /* width: 250px; */
  bottom: 20px;
  border-radius: 500px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border-radius: 100px;
  padding: 5px 10px;
}

#navigation .navBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
  background: transparent;
  line-height: 44px;
  min-width: 44px;
  min-height: 44px;
  margin-left: 8px;
  margin-right: 8px;
  font-size: 24px;
  cursor: pointer;
}

#navigation .navBtn:focus-visible,
#navigation .navBtn:hover {
  outline: 2px solid #fff;
  outline-offset: 2px;
  border-radius: 50%;
}

#navigation .navBtn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
</style>
